// The one code every door answers while a person's acceptance does not cover the Terms in force
// (ADR-032, S37.07). Its owner is onboarding, whose contract words it; it sits here because the
// browser's framework turns it into the gate and must not take an error page for an answer.
export const TERMS_REQUIRED_CODE = "onboarding_terms_required";
